import { AsyncPipe, NgIf, NgSwitch, NgSwitchCase } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { MatButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { take } from 'rxjs';
import { ConfigurationDialogManager } from './configuration-dialog-manager';
import { DatatablePageConfigurationComponent } from './page-configuration-content/datatable-page-configuration/datatable-page-configuration.component';

export interface IPageConfigurationInputs {
  manager: ConfigurationDialogManager;
  dialogTitle?: string;
}

@Component({
  imports: [
    AsyncPipe,
    NgSwitch,
    DatatablePageConfigurationComponent,
    NgSwitchCase,
    MatDialogTitle,
    TranslateModule,
    MatDialogContent,
    MatButton,
    MatDialogActions,
    MatDialogClose,
    NgIf,
  ],
  selector: 'app-page-configuration',
  styleUrl: './page-configuration.component.scss',
  templateUrl: './page-configuration.component.html',
})
export class PageConfigurationComponent implements OnInit {
  private readonly dialogRef = inject(MatDialogRef<PageConfigurationComponent>);
  public readonly dialogData = inject<IPageConfigurationInputs>(MAT_DIALOG_DATA);

  public uncommittedChanges: (string | number)[][] = [];

  public ngOnInit(): void {
    this.dialogData.manager.configurationsSubject.subscribe((configurations) => {
      this.uncommittedChanges = configurations?.configurationTabs.map(() => []) ?? [];
    });
  }

  public apply(isSetAsDefault: boolean): void {
    this.dialogData.manager.configurationsSubject.pipe(take(1)).subscribe((configurations) => {
      this.dialogData.manager.onApply.next({
        configurations:
          configurations?.configurationTabs.map((configuration, index) => ({
            ids: this.uncommittedChanges[index],
            type: configuration.type,
          })) ?? [],
        isSetAsDefault,
      });
    });

    this.dialogRef.close();
  }
}
